import { createOneOffPayment } from '@/api/query/payment';
import { getCurrentPriceConfig } from '@/api/query/price-config';
import { CheckoutContext } from '@/common/contexts/checkoutContext';
import { IpStatsContext } from '@/common/contexts/IpStatsContext';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import { getUtms } from '@/common/helpers/getUtms';
import useQueryMemo from '@/common/hooks/urlMemo';
import { PAYMENT_TYPES } from '@/pages/customer/paywall/components/PlanView';
import { useContext, useEffect, useRef, useState } from 'react';
import { useMutation } from 'react-query';

const useMakeOnePagePayuPaymentV5 = () => {
	const queryMemo = useQueryMemo();
	const { lang } = useContext(LanguageContext);
	const { handleSendIPstats, handleFbStats } = useContext(IpStatsContext);
	const { quizVersion, spVersion } = useContext(CheckoutContext);

	const [email, setEmail] = useState();
	const [promo, setPromo] = useState();
	const [correctionEmail, setCorrectionEmail] = useState();
	const [selectedOption, setSelectedOption] = useState();

	const emailRef = useRef();

	const handleEmailChange = () => {};

	const handleLoadPricesMutation = useMutation({
		mutationFn: (value) => getCurrentPriceConfig(value),
		onSuccess: ({ data }) => {
			const prices = data.prices.sort((a, b) => a.full_price - b.full_price);
			const plan = localStorage.getItem('plan');
			const selected =
				prices?.find((p) => p?.type?.value === plan) || prices[0];
			setSelectedOption(() => selected);
		},
	});

	const handleRegisterOnePageViewMutation = useMutation({
		mutationFn: (payload) => createOneOffPayment(payload),
		onSuccess: ({ data }) => {
			localStorage.setItem('user_register', JSON.stringify(data.customerId));
			window.location.href = data.link;
		},
	});

	const handleCreateOrder = (e) => {
		e?.preventDefault();

		const payload = {};
		payload.email = emailRef?.current?.value?.toLowerCase() || email;
		payload.paymentUtms = getUtms(queryMemo);
		payload.lang = lang;
		payload.plan = selectedOption._id;
		payload.promo = promo;
		payload.type = PAYMENT_TYPES.PAYU;

		handleFbStats('InitiateCheckout', {});
		handleFbStats('AddPaymentInfo', {});

		window?.gtag('event', 'initiate_checkout', {});
		window?.gtag('event', 'add_payment_info', {});

		window?.fbq('track', 'InitiateCheckout');
		window?.fbq('track', 'AddPaymentInfo');

		window?.uetq?.push('event', 'subscribe');

		const additionalTextToEvent = '_CHECKOUT_E';

		handleSendIPstats(
			`AD_${quizVersion}_CHECKOUT_${spVersion}_SUM${additionalTextToEvent}`,
		);

		if (promo) {
			if (selectedOption.type.value === 'PREMIUM') {
				handleSendIPstats(
					`AD_${quizVersion}_CHECKOUT_${spVersion}6MO_PROMO${additionalTextToEvent}`,
				);
			}
			if (selectedOption.type.value === 'PRO') {
				handleSendIPstats(
					`AD_${quizVersion}_CHECKOUT_${spVersion}3MO_PROMO${additionalTextToEvent}`,
				);
			}
			if (selectedOption.type.value === 'BASIC') {
				handleSendIPstats(
					`AD_${quizVersion}_CHECKOUT_${spVersion}1MO_PROMO${additionalTextToEvent}`,
				);
			}
		} else {
			if (selectedOption.type.value === 'PREMIUM') {
				handleSendIPstats(
					`AD_${quizVersion}_CHECKOUT_${spVersion}6MO${additionalTextToEvent}`,
				);
			}
			if (selectedOption.type.value === 'PRO') {
				handleSendIPstats(
					`AD_${quizVersion}_CHECKOUT_${spVersion}3MO${additionalTextToEvent}`,
				);
			}
			if (selectedOption.type.value === 'BASIC') {
				handleSendIPstats(
					`AD_${quizVersion}_CHECKOUT_${spVersion}1MO${additionalTextToEvent}`,
				);
			}
		}

		handleRegisterOnePageViewMutation.mutate(payload);
	};

	useEffect(() => {
		const payload = {
			country: lang === 'cs' ? 'cz' : lang,
		};

		handleLoadPricesMutation.mutate(payload);
	}, []);

	useEffect(() => {
		setTimeout(() => {
			const email = localStorage.getItem('quiz_email');

			if (email && email?.includes('@')) {
				setEmail(() => email);
			}

			const promo = localStorage.getItem('promo');

			if (promo) {
				setPromo(() => true);
			}
		}, 100);
	}, []);

	return {
		email,
		promo,
		selectedOption,
		emailRef,
		correctionEmail,
		handleCreateOrder,
		setCorrectionEmail,
	};
};

export default useMakeOnePagePayuPaymentV5;
